import styled, { css } from 'styled-components';
import { getColor, StyleVars } from '../../utils/Styles';
import { lighten } from 'polished';

export const GroupLabel = styled.div`
	font-size: 18px;
	font-weight: 600;
`;

// OptionsWrapper is the wrapper for the row of raido options
export const OptionsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	margin: 0 -4px;
`;

// InputWrapper is the position anchor for each radio option
export const InputWrapper = styled.div`
	position: relative;
	padding: 4px;
`;

// InputLabel is the label for the radio
export const InputLabel = styled.label`
	cursor: pointer;
	margin: 0;
	padding: 12px;
	font-weight: normal;
	display: inline-block;
	border-radius: 8px;
	border: 1px solid ${getColor("gray3")};

	${({ checked }) => checked && css`
		border-color: ${getColor("primaryBrand")};
		background-color: #edf9f9;
		border-width: 3px;
		font-weight: 700;
	`}

	&:hover {
		border-color: ${lighten(0.1, getColor("primaryBrand"))};
		background-color: #edf9f9;
	}
`;

// InputRadio is the radio
export const InputRadio = styled.input.attrs({
	type: 'radio',
})`
	display: none;
	position: absolute;
	opacity: 0;
`;
